import forEach from 'lodash/forEach';

const parseTypeAheadOneData = (resData) => {
  const data = resData.results;
  const suggestions = [];
  if (data && data.merchants && data.merchants.length > 0) {
    const suggestionArray = data.merchants.slice(0, 5);
    forEach(suggestionArray, (suggestionValue) => {
      if (suggestionValue && suggestionValue.name) {
        suggestions.push(suggestionValue.name);
      }
    });
  }
  return suggestions;
};

export default parseTypeAheadOneData;
